"use client";

import { SideBySideLayout } from "@ui/components/core/Disc/SideBySideDiscs";

export interface SideBySideOmniboxLayoutProps {
  leftContent: React.ReactNode;
  rightContent: React.ReactNode;
  leftLabel: string;
  rightLabel: string;
}

/**
 * Styled wrapper for side-by-side omnibox content with consistent padding.
 * Used by voice cloning, voice isolation, and similar demo views.
 */
export function SideBySideOmniboxLayout({
  leftContent,
  rightContent,
  leftLabel,
  rightLabel,
}: SideBySideOmniboxLayoutProps) {
  return (
    <div className='tw-flex tw-size-full tw-flex-1 tw-items-center tw-justify-center'>
      <div className='tw-w-56 sm:tw-w-80 md:tw-w-[35rem]'>
        <SideBySideLayout
          size='responsive-md'
          showCenterDivider={false}
          leftLabel={leftLabel}
          rightLabel={rightLabel}
          leftContent={leftContent}
          rightContent={rightContent}
        />
      </div>
    </div>
  );
}
